import { render } from "./StafetMailudsendelseList.vue?vue&type=template&id=37c291e7"
import script from "./StafetMailudsendelseList.vue?vue&type=script&lang=js"
export * from "./StafetMailudsendelseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__